export default __webpack_public_path__ + "static/media/loginBox.09c2d106.png";